import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: '100%',
        // TODO: Background has a pattern, but because of usage of app-bar the pattern cannot be applied.
        backgroundColor: theme.palette.secondary.main,
    },
    contentCenterWrapper: {
        margin: 'auto 0',
    },
    roleButtonsWrapper: {
        marginTop: theme.spacing(8),
    },
    roleButton: {
        padding: theme.spacing(5),
        backgroundColor: theme.palette.background.default,
        color: theme.palette.secondary.main,
        borderRadius: theme.shape.borderRadius,
        width: 200,
        height: 200,
        boxSizing: 'border-box',
        margin: theme.spacing(6),
        textDecoration: 'none',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(3),
            width: 160,
            height: 160,
            margin: theme.spacing(3),
        },
        transition: 'color, background-color 0.3s',
        '&:hover, &:focus': {
            color: theme.palette.background.default,
            backgroundColor: theme.palette.logo.blue.dark,
        },
    },
    roleButtonIcon: {
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            marginBottom: theme.spacing(0.5),
        },
    },
    roleButtonText: {
        fontSize: theme.typography.pxToRem(10),
    },
    actHealthColors: {
        '&$root': {
            backgroundColor: theme.palette.actHealth.main,
        },
        '& $roleButton': {
            color: theme.palette.actHealth.main,
            '&:hover, &:focus': {
                color: theme.palette.background.default,
                backgroundColor: theme.palette.actHealth.dark,
            },
        },
    },
}));
